export const ImageParagraph = ({ paragraph }) => (
  <>
    {Array.isArray(paragraph.src) ? (
      <div className={`flex flex-wrap justify-start items-start mb-3 ${paragraph.class}`}>
      {paragraph.src.map((img, index) => (
        <img 
          key={index}
          src={`${img.src.replace('/static/img/', '/img/')}`} 
          className={`img img-fluid ${img.class}`} 
          loading="lazy"
        />
      ))}
      </div>
    ) : (
      <img src={`${paragraph.src.replace('/static/img/', '/img/')}`} className="img img-fluid" loading="lazy" />
    )}
    <div className="flex flex-col gap-4">
      <p className="text-sm text-gray-500">{paragraph.caption}</p>
    </div>
    </>
); 